/**
 * کشور و شهرِ بازیکن.
 *
 * کشور از IP ِ خودِ بازیکن است و سرور تشخیصش می‌دهد (Backend/internal/geo)؛
 * کنارِ آواتار پرچمِ کشور دیده می‌شود ([[CountryFlag]]) و نامش فقط در
 * راهنمای همان پرچم. شهر اختیاری است، فقط برای ایران، و از فهرستِ ثابت (نه
 * متنِ آزاد) تا دشنام و شوخی به میز نرسد — آینه‌ی Backend/internal/auth/place.go
 * و Services/Place.cs ِ اپ؛ سرور جز این‌ها را رد می‌کند.
 */

/** مرکزِ ۳۱ استان + چند شهرِ بزرگ. فقط با ایران. */
export const IRAN_CITIES: readonly string[] = [
  "تهران", "مشهد", "اصفهان", "کرج", "شیراز", "تبریز", "قم", "اهواز", "کرمانشاه", "ارومیه",
  "رشت", "زاهدان", "همدان", "کرمان", "یزد", "اردبیل", "بندرعباس", "اراک", "زنجان", "سنندج",
  "قزوین", "خرم‌آباد", "گرگان", "ساری", "شهرکرد", "بجنورد", "بیرجند", "ایلام", "بوشهر", "سمنان",
  "یاسوج", "کیش", "قشم", "کاشان", "نجف‌آباد", "دزفول", "آبادان", "بابل", "آمل", "نیشابور",
];

let names: Intl.DisplayNames | null | undefined;

/** نامِ فارسیِ کشور از خودِ مرورگر؛ اگر نداشت، همان کد. */
export function countryName(code: string): string {
  if (!code) return "";
  if (names === undefined) {
    try { names = new Intl.DisplayNames(["fa"], { type: "region" }); } catch { names = null; }
  }
  try { return names?.of(code) ?? code; } catch { return code; }
}

/**
 * برچسبِ کوتاهِ جا کنارِ نام: فقط شهر، و فقط با ایران. کشور را نقشه‌ی کنارِ
 * آواتار می‌گوید و تکرارش در متن فقط جا می‌گیرد.
 */
export function placeLabel(p: { country?: string; city?: string }): string {
  return p.country === "IR" && p.city ? p.city : "";
}
